import {
  createSocialLinkApi,
  deleteSocialLinkApi,
  getSocialLinkApi,
  getSocialLinksApi,
  updateSocialLinkApi,
} from "api/socialLinks";
import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
} from "redux-saga/effects";
import {
  createSocialLinkFailure,
  createSocialLinkSuccess,
  deleteSocialLinkFailure,
  deleteSocialLinkSuccess,
  getSocialLinkFailure,
  getSocialLinkSuccess,
  getSocialLinksFailure,
  getSocialLinksSuccess,
  updateSocialLinkFailure,
  updateSocialLinkSuccess,
} from "./actions";
import {
  CREATE_SOCIAL_LINK,
  DELETE_SOCIAL_LINK,
  GET_SOCIAL_LINK,
  GET_SOCIAL_LINKS,
  UPDATE_SOCIAL_LINK,
} from "./actionTypes";

function* getSocialLinksSaga({ payload }) {
  try {
    const { data } = yield call(getSocialLinksApi, payload);
    yield put(getSocialLinksSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSocialLinksFailure(error));
  }
}

// ===================================================
// ===================================================

function* getSocialLinkSaga({ payload }) {
  try {
    const { data } = yield call(getSocialLinkApi, payload);
    yield put(getSocialLinkSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(getSocialLinkFailure(error));
  }
}

// ===================================================
// ===================================================

function* createSocialLinkSaga({ payload }) {
  try {
    const { data, success } = yield call(createSocialLinkApi, payload);
    yield put(createSocialLinkSuccess(data));
    if (success) {
      yield payload?.toast?.success("تم إنشاء وسيلة التواصل بنجاح");
      yield payload?.navigate("/social-links");
    }
  } catch (error) {
    console.log(error);
    yield put(createSocialLinkFailure(error));
  }
}

// ===================================================
// ===================================================

function* updateSocialLinkSaga({ payload }) {
  try {
    const { data, success } = yield call(updateSocialLinkApi, payload);
    yield put(updateSocialLinkSuccess(data));
    if (success) {
      yield payload?.toast?.success("تم تحديث وسيلة التواصل بنجاح");
      yield payload?.navigate("/social-links");
    }
  } catch (error) {
    console.log(error);
    yield put(updateSocialLinkFailure(error));
  }
}

// ===================================================
// ===================================================

function* deleteSocialLinkSaga({ payload }) {
  try {
    yield call(deleteSocialLinkApi, payload);
    yield put(deleteSocialLinkSuccess(payload));
  } catch (error) {
    console.log(error);
    yield put(deleteSocialLinkFailure(error));
  }
}

// ===================================================
// ===================================================

export function* watchGetSocialLinks() {
  yield takeEvery(GET_SOCIAL_LINKS, getSocialLinksSaga);
}

export function* watchCreateSocialLink() {
  yield takeLatest(CREATE_SOCIAL_LINK, createSocialLinkSaga);
}

export function* watchUpdateSocialLink() {
  yield takeLatest(UPDATE_SOCIAL_LINK, updateSocialLinkSaga);
}
export function* watchDeleteSocialLink() {
  yield takeLatest(DELETE_SOCIAL_LINK, deleteSocialLinkSaga);
}

export function* watchGetSocialLink() {
  yield takeEvery(GET_SOCIAL_LINK, getSocialLinkSaga);
}

// ===================================================
// ===================================================

function* socialLinksSaga() {
  yield all([fork(watchGetSocialLinks)]);
  yield all([fork(watchDeleteSocialLink)]);
  yield all([fork(watchUpdateSocialLink)]);
  yield all([fork(watchCreateSocialLink)]);
  yield all([fork(watchGetSocialLink)]);
}

export default socialLinksSaga;
